import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-lead-status-tabs',
  templateUrl: './lead-status-tabs.component.html',
  styleUrls: ['./lead-status-tabs.component.scss'],
})
export class LeadStatusTabsComponent {
  @Input() stages: { stage_name: string; probability?: number }[] = [];
  @Input() currentStatus = '';
  @Input() disabled = false;
  /** When true the tabs are display-only; clicks are ignored. */
  @Input() readonly = false;
  @Output() statusChange = new EventEmitter<string>();

  get scrollable(): boolean {
    return (this.stages?.length ?? 0) > 5;
  }

  isActive(stageName: string): boolean {
    return this.norm(stageName) === this.norm(this.currentStatus);
  }

  getCurrentStageIndex(): number {
    if (!this.stages || !this.currentStatus) return -1;
    return this.stages.findIndex(
      (s) => this.norm(s.stage_name) === this.norm(this.currentStatus)
    );
  }

  isPassed(stageName: string): boolean {
    const activeIndex = this.getCurrentStageIndex();
    if (activeIndex === -1) return false;
    const idx = this.stages.findIndex(
      (s) => this.norm(s.stage_name) === this.norm(stageName)
    );
    return idx !== -1 && idx < activeIndex;
  }

  onTabClick(stageName: string): void {
    if (this.disabled || this.readonly || this.isActive(stageName)) {
      return;
    }
    this.statusChange.emit(stageName);
  }

  private norm(v: string): string {
    return (v || '').trim().toLowerCase();
  }
}
